import { Schema, z } from 'zod';
import { ContentType, ContentTypeSchema } from './schema/commons';

/**
 * Asset type with details regarding the asset location.
 * @typedef Asset
 * @property - contentType : One of the Content type
 * @property - description : Description of the asset field
 * @property - details : Additional details for the asset
 * @property - fileName : Name of the file including the extension
 * @property - title : Title of the file
 * @property - url : Location of the asset. i.e. http link, directory path
 */
export type Asset = {
  contentType: ContentType;
  description: string;
  details: {
    image?: {
      height: number;
      width: number;
    };
    size?: number;
  };
  fileName: string;
  title: string;
  url: string;
};

export const AssetSchema: Schema<Asset> = z.object({
  contentType: ContentTypeSchema,
  description: z.string(),
  details: z.object({
    image: z
      .object({
        height: z.number(),
        width: z.number()
      })
      .optional(),
    size: z.number().optional()
  }),
  fileName: z.string(),
  title: z.string(),
  url: z.string()
});
